import React from 'react';
import { getBrandCodeDomain } from '../utils/utils';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  let brand  = getBrandCodeDomain();

  // Set Footer Link
  let legalInfo = "https://www.natwest.com/website-terms-and-FSCS.html";
  let privacy_cookies = "https://www.natwest.com/global/cookie-privacy.html";
  let security = "https://www.natwest.com/fraud-and-security.html";
  let accessibility = "https://www.natwest.com/accessibility.html";
  let copyright = " © National Westminster Bank plc " + new Date().getFullYear();

  if(brand === 'rbs'){
     legalInfo = "https://www.rbs.co.uk/website-terms-and-FSCS.html";
     privacy_cookies = "https://www.rbs.co.uk/global/cookie-privacy.html"
     security = "https://www.rbs.co.uk/fraud-and-security.html";
     accessibility = "https://www.rbs.co.uk/accessibility.html";
     copyright = "© Royal Bank of Scotland plc " + new Date().getFullYear();
  }else if(brand === 'ubn'){
     legalInfo = "https://www.ulsterbank.co.uk/globals/website-terms-and-conditions.html";
     privacy_cookies = "https://www.ulsterbank.co.uk/globals/cookie-privacy.html"
     security = "https://www.ulsterbank.co.uk/fraud-and-security.html";
     accessibility = "https://www.ulsterbank.co.uk/globals/accessibility.html";
     copyright = "© "+ new Date().getFullYear()+" Ulster Bank, a business name of National Westminster Bank Plc";
  }else if(brand === 'natwesti'){
     legalInfo = "https://www.natwestinternational.com/global/terms-conditions.html";
     privacy_cookies = "https://www.natwestinternational.com/global/cookies-policy.html";
     security = "https://www.natwestinternational.com/global/fraud-and-security.html";
     accessibility = "https://www.natwestinternational.com/global/accessibility.html";
     copyright = "© The Royal Bank of Scotland International Limited trading as NatWest International";
 }

  return(  
    <footer className='zb-footer'>
        <ul style={{padding:0}}>
          <li className="display-vm">
            <a id='legalInfo' href={legalInfo} target="_blank" aria-label={t("Legal Information opens in new tab")} rel="noreferrer" className="zb-button zb-button-link">{t('Legal info')}</a>
          </li>
          <li className="display-vm">
            <a id='security' href={security} target="_blank" aria-label={t("Security opens in new tab")} rel="noreferrer" className="zb-button zb-button-link">{t('Security')}</a>
          </li>
          <li className="display-vm">
            <a id='privacy_cookies' href={privacy_cookies} target="_blank" aria-label={t("Privacy and Cookies opens in new tab")} rel="noreferrer" className="zb-button zb-button-link">{t('Privacy & Cookies')}</a>
          </li>
          <li className="display-vm">
            <a id='accessibility' href={accessibility} target="_blank" aria-label={t("Accessibility opens in new tab")} rel="noreferrer" className="zb-button zb-button-link">{t('Accessibility')}</a>
          </li>
        </ul>
        <div className='zb-footer-text' aria-labelledby="Copyright Information">{t(copyright)}</div>
    </footer>
  );
}
export default Footer;